import React, { useEffect, useState, useContext } from "react";
import "./Dashboardv2.scss";
import Button from "@material-ui/core/Button";
import Axios from "axios";
import Banner from "../../Components/Banner";
import Navbar from "../../Components/Navbar";
import Navbarv2 from "../../Components/Navbarv2/Navbarv2";
import SimpleTabs from "../../Components/Tabs";
import SimpleTabsv2 from "../../Components/Tabsv2/Tabsv2";
import StateContext from "../../StateContext";
import DispatchContext from "../../DispatchContext";
import Snackbar from "@material-ui/core/Snackbar";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import {
  useHistory,
  BrowserRouter,
  Switch,
  Redirect,
  Route,
} from "react-router-dom";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Page from "../../Components/Page";
import Orders from "../../Components/Orders";
// import Ordersv2 from "../../Components/Ordersv2/Ordersv2"
import Ordersv2 from "../../Components/Ordersv2Latest/Ordersv2"
import Promocodes from "../../Components/Promocodes";
import Promocodesv2 from "../../Components/Promocodesv2/Promocodesv2";
import Profile from "../../Components/Profile";
import Transactions from "../../Components/Transactions";
import Transactionsv2 from "../../Components/transactionsv2/transactionsv2";
// import localizations pakeges
import { withTranslation, useTranslation, Trans } from "react-i18next";
import Rewards from "../../Components/Rewards";
import { getByDisplayValue } from "@testing-library/dom";
import WalletTab from "../../Components/WalletTab";
import Error404 from "../Error404/error404";
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    height: "100vh",
    alignItems: "center",
  },
}));
function Dashboardv2(props) {
  let history = useHistory();
  const { t } = useTranslation();
  const classes = useStyles();
  const appState = useContext(StateContext);
  const appDispatch = useContext(DispatchContext);
  // const [isLoading, setIsLoading] = useState(true)
  const [value, setValue] = useState(0);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [title, setTitle] = useState(t("dashboard.transactions"));


  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChange = (event, newValue) => {
    // console.log(newValue)
    if (newValue == 0) {
      setTitle(t("dashboard.transactions"));
    } else if (newValue == 1) {
      setTitle(t("dashboard.your-orders"));
    } else if (newValue == 2) {
      setTitle(t("dashboard.promocodes"));
    } else if (newValue == 3) {
      setTitle(t("dashboard.rewards"));
    } else if (newValue == 4) {
      setTitle(t("dashboard.my-profile"));
    }

    setValue(newValue);
  };
  useEffect(() => {
    let initial = true;
    if(initial){
      if (window.location.pathname === "/dashboard") {
        setValue(1);
        setTitle(t("dashboard.orders"));
      }
    }
  
    return () => {
      initial = false;
    }
  }, [])
  

  const [count, setCount] = useState(0);
  if (!appState.loggedIn) {
    history.push("/");
  }

  // Fetching Data --------------------------------------------------------------------

  //-------- Fetch Complete --------------------------------
  if (appState.loggedIn) {
    // console.log("login he bhai")
    return (
      <div   className={` ${appState.langValue === "ar" ? "directionRtl" : ""}`} id="dashboardv2">

        {appState.alertMessage ? (
          <Snackbar
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            message={appState.alertMessage.Message}
            open={appState.alertMessage.open}
          />
        ) : (
          <div class="empt"></div>
        )}
        <Navbarv2 handleChange={handleChange} />
      
        <div className="main_area">
        <SimpleTabsv2
            title={title}
            handleChange={handleChange}
            value={value}
          />
          <div>
            <Switch>
              {appState.loggedIn ? "" : <Redirect to="/" />}
              <Route exact path="/">
                <Page title="Dashboard">
                  {/* <Transactions setCount={setCount} /> */}
                  <Ordersv2 setCount={setCount} />
                  <Profile />
                </Page>
              </Route>
              <Route exact path="/dashboard">
                <Page title="Dashboard">
                  {/* <Transactions setCount={setCount} /> */}
                  <Ordersv2 setCount={setCount} />
                  </Page>
              </Route>
              <Route exact path={`/dashboard/transactions`}>
                {/* <Transactions setCount={setCount} /> */}
                <Transactionsv2 setCount={setCount} />
                {/* <Promocodes setCount={setCount} /> */}
              </Route>
              {/* <Route exact path={`/dashboard/wallet`}>
                <WalletTab />
              </Route> */}
              <Route exact path={`/dashboard/promo`}>
                <Promocodesv2 setCount={setCount} />
                {/* <Transactions setCount={setCount} /> */}
              </Route>
              <Route exact path={`/dashboard/profile`}>
                <Profile />
              </Route>
              <Route exact path={`/dashboard/orders`}>
                {/* <Orders setCount={setCount} /> */}
                <Ordersv2 setCount={setCount} />
              </Route>
              <Route exact path={`/dashboard/rewards`}>
                <Rewards />
              </Route>
              <Route path="*">
                <Error404/>
              </Route>
            </Switch>
          </div>
        </div>
      </div>


    );
  }
}

export default withTranslation()(Dashboardv2);
